import { Pill } from "../kit/Kit";

export const CAT = { acceso: "Acceso", "acción": "Acción", denegado: "Denegado", lectura_sensible: "Descarga/exportación", sistema: "Sistema", ai: "Trafalgar AI" };
export const RES_CLS = { ok: "bg-emerald-50 text-emerald-700 border-emerald-200", denegado: "bg-rose-50 text-rose-700 border-rose-200", error: "bg-amber-50 text-amber-800 border-amber-200" };
export const inp = "w-full rounded-lg border border-[#E2DDD5] bg-white px-3 py-2 text-sm outline-none focus:border-[#E8643C]";

export const Res = ({ r }) => <Pill cls={RES_CLS[r] || "bg-slate-50 text-slate-600 border-slate-200"}>{r || "—"}</Pill>;

export const Vacio = ({ children = "Sin registros", testid }) => <p className="py-8 text-center text-sm text-[#8C867A]" data-testid={testid}>{children}</p>;

export const val = (v) => (v === null || v === undefined || v === "" ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));
